import React from 'react';

import { SPACER } from '../../../../shared/constants';
import { type SpacerField } from '../../../../shared/types';

import styles from './PreviewFields.module.css';

interface SpacerProps {
  field: SpacerField;
}

function Spacer({ field }: SpacerProps) {
  const height = field.height ?? SPACER.DEFAULT_HEIGHT;

  return <div className={styles.spacer} style={{ height: `${height}px` }} />;
}

export default Spacer;
